/**
 *
 * Settings
 *
 */

import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Container,
  Box,
  Chip,
  Drawer,
  Divider,
  IconButton,
  Button,
  Typography,
  Autocomplete,
  Grid,
  TextField,
  Tabs,
  Tab,
  Tooltip,
  List,
  ListItem,
  MenuItem,
  InputBase,
} from "@material-ui/core";
import LoadingButton from "@material-ui/lab/LoadingButton";
import CloseIcon from "@material-ui/icons/Close";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import AddBoxIcon from "@material-ui/icons/AddBox";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import DatePicker from "@material-ui/lab/DatePicker";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import "./styles.scss";
import autoBind from "react-autobind";
import {
  handleInputChange,
  handleDateChange,
  handleReactSelect,
} from "../../utils/inputHandlers";
import { getUserInfo } from "../../utils/functions";
import { Auth0Context } from "../../auth0-wrapper";
import Logo from "../../images/tn_logo.svg";
import LogoPA from "../../images/pa_logo_new.svg";
import LogoDisAMR from "../../images/disamr-logo.svg";

const LogoPAjsx = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="301"
    height="66"
    fill="none"
    viewBox="0 0 301 66"
  >
    <g fill="#F58426">
      <path d="M115.17 52c-.65-.59-1.76-.88-3.4-.88h-3.07c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-5.79h.96c1.51 0 2.63-.33 3.33-1 .67-.64 1.02-1.65 1.04-3.02v-.2c-.02-1.44-.34-2.42-.97-2.99m-3.41 5.18h-.96v-4.02h.96c.78 0 1.32.14 1.59.42q.405.405.42 1.56c0 .79-.15 1.35-.4 1.62-.27.28-.81.42-1.61.42M121.67 50.96c-1.44 0-2.5.37-3.15 1.1-.64.72-.97 1.89-.97 3.48v5.02c0 1.82.29 3.05.89 3.77s1.69 1.08 3.23 1.08c1.43 0 2.49-.33 3.14-.98s.98-1.69.98-3.11V55.6c0-1.66-.31-2.83-.95-3.55s-1.71-1.1-3.17-1.1zm-1.76 4.61c0-.94.14-1.62.43-2.02.27-.38.7-.56 1.33-.56.68 0 1.15.15 1.38.44.17.21.38.7.38 1.79v5.72c0 .89-.14 1.53-.42 1.9-.27.36-.71.53-1.33.53-.67 0-1.13-.18-1.37-.54-.26-.39-.39-1.14-.39-2.24v-5.02zM139.69 51.12h-1.79c-.12 0-.23.09-.25.21l-1.38 9.13-1.34-9.13a.25.25 0 0 0-.25-.21h-2.24c-.12 0-.23.09-.25.21l-1.37 9.22-1.35-9.22a.25.25 0 0 0-.25-.21h-1.81c-.07 0-.14.03-.19.09s-.07.13-.06.2l2.3 13.63c.02.12.12.21.25.21h2.14c.12 0 .23-.09.25-.21l1.44-9.58 1.43 9.58c.02.12.12.21.25.21h2.14c.12 0 .23-.09.25-.21l2.33-13.63c.01-.07 0-.15-.05-.2a.25.25 0 0 0-.19-.09zM147.72 63.21h-4.12v-4.2h3.74c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25h-3.74v-3.82h3.99c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25h-6.1c-.14 0-.25.11-.25.25v13.63c0 .14.11.25.25.25h6.23c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25zM157.56 63.28l-.04-.32c-.06-.54-.1-1.22-.11-2.03-.02-1.2-.24-2-.67-2.45-.19-.2-.45-.35-.78-.46.32-.14.59-.3.81-.51.63-.58.97-1.49 1-2.71v-.19c-.03-1.14-.32-2.01-.88-2.58-.59-.6-1.49-.91-2.68-.91h-4.32c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-5.92h1.21c.65 0 1.11.16 1.38.47.28.33.42.91.44 1.73.01.68.05 1.33.1 1.9l.03.29c.01.15.04.35.09.59.04.24.11.56.2.99.02.12.13.2.24.2h1.96c.08 0 .15-.04.2-.1a.25.25 0 0 0 .04-.22q-.12-.39-.18-.75c-.05-.25-.09-.54-.14-.89zm-2.15-8.47c0 .88-.16 1.47-.44 1.77-.29.3-.87.46-1.73.46h-1.23v-3.88h1.23c1.07 0 1.54.2 1.75.36.27.22.42.66.43 1.29zM165.95 63.21h-4.12v-4.2h3.74c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25h-3.74v-3.82h3.99c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25h-6.1c-.14 0-.25.11-.25.25v13.63c0 .14.11.25.25.25h6.23c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25zM171.47 51.12h-3.32c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h4.36c1.28 0 2.23-.37 2.81-1.1.58-.72.85-1.85.85-3.43v-5.31c0-1.49-.38-2.59-1.13-3.27-.74-.67-1.94-1.01-3.57-1.01zm2.34 4.31v5.31c0 .95-.14 1.62-.42 1.97-.26.33-.76.5-1.48.5h-1.64V53.15h1.44c.81 0 1.36.16 1.66.47.3.32.45.93.45 1.8zM188.69 57.98c.27-.12.5-.26.69-.43.65-.56.97-1.47.97-2.7v-.07c0-1.24-.36-2.17-1.08-2.77-.7-.59-1.78-.89-3.21-.89h-3.31c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h3.64c1.54 0 2.61-.29 3.29-.88.67-.59 1.02-1.58 1.02-2.93v-.07c0-1.38-.35-2.35-1.03-2.89-.26-.21-.58-.37-.98-.5m-.7-2.82c0 .67-.14 1.15-.41 1.43q-.405.42-1.38.42h-1.33v-3.86h1.2c.67 0 1.16.16 1.46.46s.46.8.46 1.47v.08m-3.12 3.89h1.33c.81 0 1.37.15 1.68.44.3.29.46.81.46 1.56v.07c0 .76-.15 1.31-.45 1.62-.29.31-.79.47-1.49.47h-1.53v-4.17zM199.98 51.12h-1.92c-.11 0-.2.07-.24.17l-1.8 5.33-1.81-5.33a.25.25 0 0 0-.24-.17h-2.11a.26.26 0 0 0-.21.11.24.24 0 0 0-.03.23l3.11 7.86V65c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-5.7l3.1-7.84c.03-.08.02-.16-.03-.23a.25.25 0 0 0-.21-.11zM214.17 51.12h-1.73c-.14 0-.25.11-.25.25v10.06l-3.04-10.13a.246.246 0 0 0-.24-.18h-2.94c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h1.77c.14 0 .25-.11.25-.25v-9.99L211 65.07c.03.11.13.18.24.18h2.93c.14 0 .25-.11.25-.25V51.37c0-.14-.11-.25-.25-.25M218.43 51.12h-1.86a.25.25 0 0 0-.25.25V65c0 .138.112.25.25.25h1.86a.25.25 0 0 0 .25-.25V51.37a.25.25 0 0 0-.25-.25M224.89 50.96c-1.42 0-2.48.36-3.12 1.06s-.97 1.83-.97 3.35v6.06c0 1.33.34 2.34 1 2.99s1.68.98 3.02.98 2.38-.36 2.98-1.07c.61-.71.88-1.82.83-3.37v-.41c0-.14-.11-.25-.25-.25h-1.86c-.14 0-.25.11-.25.25v.41c.01.88-.11 1.52-.35 1.89-.23.34-.6.51-1.16.51-.61 0-1.03-.15-1.25-.44-.16-.22-.35-.71-.35-1.82v-6.07c0-.75.14-1.29.41-1.6.26-.3.71-.45 1.34-.45.55 0 .92.12 1.1.37.13.18.29.6.26 1.56v.41c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-.86c.02-1.12-.25-1.98-.79-2.54-.6-.64-1.59-.97-2.95-.97zM237.06 63.21h-4.12v-4.2h3.74c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25h-3.74v-3.82h3.99c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25h-6.1c-.14 0-.25.11-.25.25v13.63c0 .14.11.25.25.25h6.23c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25zM245.42 51.12h-1.86a.25.25 0 0 0-.25.25V65c0 .138.112.25.25.25h1.86a.25.25 0 0 0 .25-.25V51.37a.25.25 0 0 0-.25-.25M256.1 51.12h-1.73c-.14 0-.25.11-.25.25v10.06l-3.04-10.13a.246.246 0 0 0-.24-.18h-2.94c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h1.77c.14 0 .25-.11.25-.25v-9.99l3.01 10.06c.03.11.13.18.24.18h2.93c.14 0 .25-.11.25-.25V51.37c0-.14-.11-.25-.25-.25M262.64 56.88c-.88-.47-1.45-.84-1.7-1.11-.22-.25-.33-.62-.33-1.1 0-.6.13-1.04.38-1.29s.68-.38 1.28-.38c.52 0 .88.13 1.08.4.22.29.33.8.33 1.52v.41c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-.72c0-1.26-.27-2.18-.8-2.74-.58-.6-1.58-.91-2.98-.91s-2.37.33-3.05.97c-.69.65-1.04 1.62-1.04 2.9 0 .87.26 1.62.76 2.23s1.36 1.22 2.61 1.89c1.01.53 1.67.96 1.95 1.26.26.29.39.7.39 1.22 0 .71-.14 1.22-.43 1.51s-.77.44-1.45.44-1.1-.17-1.32-.49c-.24-.35-.36-1.04-.35-2.05v-.41c0-.14-.11-.25-.25-.25h-1.89c-.14 0-.25.11-.25.25v.77c0 1.42.28 2.47.86 3.13.63.71 1.71 1.08 3.2 1.08 1.39 0 2.45-.35 3.16-1.05s1.07-1.74 1.07-3.1c0-1-.24-1.81-.72-2.39-.48-.57-1.42-1.22-2.88-1.99zM269.85 51.12h-1.86a.25.25 0 0 0-.25.25V65c0 .138.112.25.25.25h1.86a.25.25 0 0 0 .25-.25V51.37a.25.25 0 0 0-.25-.25M276.36 50.96c-1.48 0-2.57.37-3.24 1.1-.67.72-1 1.9-1 3.49v5.02c0 1.82.3 3.06.92 3.77s1.74 1.08 3.32 1.08c1.63 0 2.93-.23 3.86-.66.09-.04.14-.13.14-.23v-6.75c0-.14-.11-.25-.25-.25h-3.95c-.14 0-.25.11-.25.25v1.54c0 .14.11.25.25.25H278v3.57c-.49.16-1.04.24-1.64.25-.71 0-1.21-.18-1.46-.55-.27-.39-.41-1.14-.41-2.24v-5.02c0-.94.15-1.62.45-2.01.28-.38.75-.57 1.43-.57.6 0 1.03.13 1.28.4s.37.73.36 1.39v.41c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-.4c.02-1.3-.3-2.28-.95-2.9s-1.68-.93-3.05-.93zM290.27 51.12h-1.86c-.14 0-.25.11-.25.25v5.6h-3.44v-5.6c0-.14-.11-.25-.25-.25h-1.86c-.14 0-.25.11-.25.25V65c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25v-5.99h3.44V65c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25V51.37c0-.14-.11-.25-.25-.25M300.38 51.12h-8.14c-.14 0-.25.11-.25.25v1.54c0 .14.11.25.25.25h2.89V65c0 .14.11.25.25.25h1.86c.14 0 .25-.11.25-.25V53.16h2.89c.14 0 .25-.11.25-.25v-1.54c0-.14-.11-.25-.25-.25M294.8 22.99h6.14v-6.21c0-5.03-2.54-7.51-7.51-7.51h-2.61c-5.03 0-7.57 2.54-7.57 7.57v19.67c0 5.03 2.54 7.57 7.57 7.57h2.61c5.03 0 7.57-2.54 7.57-7.57v-7.26h-6.14v6.89c0 1.55-.75 2.3-2.29 2.3h-.81c-1.49 0-2.23-.74-2.23-2.3V17.22c0-1.55.74-2.3 2.23-2.3h.75c1.55 0 2.29.75 2.29 2.3zM272.28 9.27h-1.99c-5.03 0-7.57 2.54-7.57 7.57v4.41h5.89v-4.22c0-1.49.81-2.29 2.3-2.29h.43c1.55 0 2.29.81 2.29 2.29v5.27l-6.51 2.24c-3.54 1.18-4.78 2.85-4.78 6.89v6.89c0 3.66 1.8 5.77 5.4 5.77h.06c2.61 0 4.28-1.18 5.89-2.54v2.17h6.14V16.85c0-5.02-2.54-7.57-7.57-7.57zm1.36 28.17c-1.12.68-2.11.99-3.23.99-1.37 0-1.98-.62-1.98-1.92v-4.84c0-1.55.43-2.17 1.8-2.79l3.41-1.3v9.87zM241.07 43.71h6.27V16.04c1.18-.68 2.17-1.05 3.35-1.05 1.43 0 2.05.62 2.05 1.99v26.74h6.27V15.11c0-3.79-1.86-5.83-5.46-5.83h-.31c-2.61 0-4.34 1.18-5.96 2.61V9.66h-6.21v34.06zM229.96 9.27h-1.99c-5.03 0-7.57 2.54-7.57 7.57v4.41h5.9v-4.22c0-1.49.81-2.29 2.3-2.29h.43c1.55 0 2.3.81 2.3 2.29v5.27l-6.52 2.24c-3.54 1.18-4.78 2.85-4.78 6.89v6.89c0 3.66 1.8 5.77 5.4 5.77h.06c2.61 0 4.28-1.18 5.89-2.54v2.17h6.14V16.85c0-5.02-2.54-7.57-7.57-7.57zm1.36 28.17c-1.12.68-2.11.99-3.23.99-1.37 0-1.99-.62-1.99-1.92v-4.84c0-1.55.44-2.17 1.8-2.79l3.41-1.3v9.87zM205.26 16.04c1.12-.68 2.11-1.05 3.23-1.05 1.3 0 1.92.62 1.92 1.92v26.8h6.27V15.04c0-3.72-1.92-5.77-5.4-5.77h-.25c-2.67 0-4.53 1.18-6.33 2.85-.81-1.86-2.42-2.85-4.84-2.85h-.25c-2.48 0-4.28 1.18-5.89 2.61V9.65h-6.2v34.06h6.27V16.04c1.18-.68 2.17-1.05 3.29-1.05 1.3 0 1.86.62 1.86 1.92v26.8h6.33V16.04zM183.73 4.05h-6.27v39.66h6.27zM166.23 9.27h-1.99c-5.03 0-7.57 2.54-7.57 7.57v4.41h5.89v-4.22c0-1.49.81-2.29 2.3-2.29h.43c1.55 0 2.29.81 2.29 2.29v5.27l-6.51 2.24c-3.54 1.18-4.78 2.85-4.78 6.89v6.89c0 3.66 1.8 5.77 5.4 5.77h.06c2.6 0 4.28-1.18 5.89-2.54v2.17h6.14V16.85c0-5.02-2.54-7.57-7.57-7.57zm1.37 28.17c-1.12.68-2.11.99-3.23.99-1.36 0-1.98-.62-1.98-1.92v-4.84c0-1.55.44-2.17 1.8-2.79l3.41-1.3v9.87zM139.33 21.89h6.08v-4.96c0-4.96-2.48-7.51-7.51-7.51h-2.11c-5.03 0-7.57 2.54-7.57 7.57v3.91c0 3.23 1.18 4.78 3.78 6.45l5.96 3.66c1.06.68 1.49 1.43 1.49 2.67v2.85c0 1.49-.74 2.23-2.23 2.23h-.81c-1.49 0-2.17-.74-2.17-2.23v-4.96h-6.08v5.15c0 4.96 2.48 7.51 7.51 7.51h2.24c5.03 0 7.57-2.55 7.57-7.57v-4.1c0-3.29-1.18-4.78-3.85-6.45l-5.9-3.72c-1.12-.68-1.49-1.37-1.49-2.61v-2.67c0-1.49.68-2.23 2.17-2.23h.68c1.49 0 2.23.75 2.23 2.23v4.78zM129.42.05h-4.26v6.34h1.53c-.11.93-.38 2.02-.93 3.39l-.66 1.64 1.75.49L128 9.89c1.2-2.18 1.42-3.06 1.42-5.63zM117.32 9.3h-1.99c-5.03 0-7.57 2.54-7.57 7.57v4.4h5.89v-4.22c0-1.49.81-2.3 2.3-2.3h.43c1.55 0 2.3.81 2.3 2.3v5.27l-6.51 2.23c-3.54 1.18-4.78 2.86-4.78 6.89v6.89c0 3.66 1.8 5.77 5.4 5.77h.06c2.61 0 4.28-1.18 5.89-2.55v2.17h6.14V16.85c0-5.03-2.54-7.57-7.57-7.57zm1.36 28.17c-1.12.68-2.11.99-3.23.99-1.36 0-1.99-.62-1.99-1.92V31.7c0-1.55.44-2.17 1.8-2.79l3.41-1.3v9.87zM94.01 16.06c1.12-.68 2.11-1.05 3.23-1.05 1.3 0 1.92.62 1.92 1.92v26.81h6.27V15.07c0-3.72-1.92-5.77-5.4-5.77h-.25c-2.67 0-4.53 1.18-6.33 2.85-.81-1.86-2.42-2.85-4.84-2.85h-.25c-2.48 0-4.28 1.18-5.89 2.61V9.68h-6.21v34.07h6.27V16.08c1.18-.68 2.17-1.05 3.29-1.05 1.31 0 1.86.62 1.86 1.92v26.81h6.33v-27.700000000000003M62.43 43.74h6.27V18.3c1.3-1.18 2.92-1.8 5.21-1.99V9.36c-2.48 0-3.85 1.24-5.28 3.97V9.67h-6.2zM51.82 9.3h-1.99c-5.03 0-7.57 2.54-7.57 7.57v4.4h5.89v-4.22c0-1.49.81-2.3 2.29-2.3h.43c1.55 0 2.3.81 2.3 2.3v5.27l-6.52 2.23c-3.54 1.18-4.78 2.86-4.78 6.89v6.89c0 3.66 1.8 5.77 5.4 5.77h.06c2.61 0 4.28-1.18 5.89-2.55v2.17h6.14V16.85c0-5.03-2.54-7.57-7.57-7.57zm1.36 28.17c-1.12.68-2.11.99-3.23.99-1.37 0-1.99-.62-1.99-1.92V31.7c0-1.55.44-2.17 1.8-2.79l3.41-1.3v9.87zM21.16 43.74h6.27V16.07c1.18-.68 2.17-1.05 3.35-1.05 1.43 0 2.05.62 2.05 1.98v26.75h6.27V15.13c0-3.79-1.86-5.83-5.46-5.83h-.31c-2.61 0-4.35 1.18-5.9 2.61V0h-6.27zM12.22 9.3h-.06c-2.61 0-4.53 1.3-5.96 2.67v-2.3H0v40.89h6.27v-8.87c1.43 1.24 3.29 2.42 5.9 2.42h.06c3.78 0 5.83-2.42 5.83-6.39V15.69c0-3.97-2.05-6.39-5.83-6.39zm-.43 26.99c0 1.49-.74 2.11-2.23 2.11-1.24 0-2.36-.43-3.29-1.12V16.12C7.2 15.44 8.32 15 9.56 15c1.49 0 2.23.62 2.23 2.11v19.180000000000003"></path>
    </g>
  </svg>
);
var ObjectID = require("bson-objectid");

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={1}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCrmCompany: undefined,
      newCompany: "",
      newDocNum: "",
      newType: "",
      newQuarter: "",
      newCustom: "",
      newDocType: "",
      newYear: "",
      newCurrency: "USD",
      newLogoInternal: Logo,
      newAddress: "New York",
      newCustomDate: null,
      newSigDate: moment().toDate(),
      newFromMember: [],
      newSalesPerson: [],
      newAccountManagement: [],
      tab: 0,
      memberOptions: [],
    };

    autoBind(this);

    this.handleInputChange = handleInputChange.bind(this);
    this.handleDateChange = handleDateChange.bind(this);
    this.handleReactSelect = handleReactSelect.bind(this);
    this.getUserInfo = getUserInfo.bind(this);
  }

  static contextType = Auth0Context; // eslint-disable-line no-undef

  componentDidMount() {
    this.injectSettings();
  }

  componentDidUpdate(prevProps) {
    // console.log(prevProps.show, this.props.show);
    if (!prevProps.show && this.props.show) {
      this.injectSettings();
    }
  }

  // static getDerivedStateFromProps(props, state) {
  //  console.log(props)
  // }

  createMemberOptions() {
    if (this.state.memberOptions.length) {
      return false;
    }

    let memberOptions = this.props.members
      ?.sort(this.compare)
      .map((member) => ({
        label: member.Name,
        value: member._id.toString(),
      }));
    if (memberOptions?.length) {
      this.setState({
        memberOptions,
      });
    }
  }

  injectSettings() {
    console.log("inject settings", this.props);
    // console.log("inject settings", this.props);
    this.setState({
      newCrmCompany: this.props.crmCompany,
      newCompany: this.props.company,
      newDocNum: this.props.docNum,
      newType: this.props.type,
      newQuarter: this.props.quarter,
      newCustom: this.props.custom,
      newDocType: this.props.docType || "Strategic Plan",
      newYear: this.props.year,
      newCustomDate: this.props.customDate || null,
      newSigDate: this.props.sigDate,
      newCurrency: this.props.currency || "USD",
      newLogoInternal: this.props.logoInternal || Logo,
      newAddress: this.props.address || "New York",
      newFromMember: this.props.fromMember || [],
      newSalesPerson: this.props.salesPerson || [],
      newAccountManagement: this.props.accountManagement || [],
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.props.approved) {
      this.props.onSubmit(this.state);
    }
  }

  handleTabChange(e, value) {
    this.setState({
      tab: value,
    });
  }

  handleReactSelectMulti(key, target) {
    this.setState(
      {
        [key]: target,
      },
      () => {
        if (key === "newSalesPerson" && this.props.approved) {
          // console.log(value)
          this.props.updatedSalesPerson(target);
        } else if (key === "newAccountManagement" && this.props.approved) {
          // console.log(value)
          this.props.updatedAccountManagement(target);
        }
      }
    );
  }

  compare(a, b) {
    let comparison = 0;
    if (a.Name > b.Name) {
      comparison = 1;
    } else if (a.Name < b.Name) {
      comparison = -1;
    }
    return comparison;
  }

  getCompanySuggestions(inputValue) {
    return axios
      .get("/api/crmGetCompany", {
        params: {
          company: inputValue,
        },
      })
      .then((response) => {
        let options = [];

        for (let result of response.data.list) {
          options.push({
            label: result.name,
            value: result.id,
          });
        }

        return options;
      })
      .catch(console.error);
  }

  render() {
    return (
      <Drawer
        id="settings-drawer"
        anchor={this.props.side ? "right" : "bottom"}
        open={this.props.show}
        variant={this.props.side ? "persistent" : "permanent"}
      >
        <Container>
          <div id={this.props.side ? "settings" : "add-doc"}>
            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="space-between"
              flexDirection="column"
            >
              <div id="main-settings">
                <div>
                  {/* <button
                type="button"
                className="close public-btn"
                aria-label="Close"
                onClick={this.props.onClick}
              >
                <span aria-hidden="true">&times;</span>
              </button> */}

                  {this.props.side && (
                    <>
                      <Box
                        mb={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography variant="h5">Settings</Typography>
                        <IconButton
                          className="public-btn"
                          size="small"
                          onClick={this.props.onClick}
                          sx={{ "&": { mr: -1 } }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                      <Divider />
                      <Grid>
                        <Tabs
                          value={this.state.tab}
                          onChange={this.handleTabChange}
                          indicatorColor="primary"
                          textColor="primary"
                          centered
                        >
                          <Tab label="Details" />
                          <Tab label="Revisions" />
                        </Tabs>
                      </Grid>
                    </>
                  )}
                  <TabPanel id="main-tab" value={this.state.tab} index={0}>
                    <form onSubmit={(e) => this.handleSubmit(e)}>
                      {!isNaN(this.state.newDocNum) && (
                        <TextField
                          fullWidth
                          margin="normal"
                          label="SOW Number"
                          variant="outlined"
                          type="number"
                          size="small"
                          name="newDocNum"
                          value={this.state.newDocNum}
                          onChange={this.handleInputChange}
                          required
                          InputLabelProps={{ required: false }}
                          disabled={this.props.approved}
                        />
                      )}
                      <TextField
                        fullWidth
                        margin="normal"
                        label="Company Name"
                        variant="outlined"
                        type="text"
                        size="small"
                        name="newCompany"
                        value={this.state.newCompany}
                        onChange={this.handleInputChange}
                        required
                        InputLabelProps={{ required: false }}
                        disabled={this.props.approved}
                      />

                      <Autocomplete
                        autoHighlight
                        disableClearable
                        value={
                          (this.state.newType && {
                            value: this.state.newType,
                            label: this.state.newType,
                          }) ||
                          null
                        }
                        options={[
                          { value: "AOR", label: "AOR" },
                          { value: "PA", label: "PA" },
                          { value: "Custom", label: "Custom" },
                          { value: "disAMR", label: "disAMR" },
                        ]}
                        getOptionLabel={(option) => option?.label || ""}
                        getOptionSelected={(option, value) =>
                          option.value === value.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Contract Type"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            required
                            InputLabelProps={{ required: false }}
                          />
                        )}
                        onChange={(e, value) =>
                          this.handleReactSelect("newType", value)
                        }
                        disabled={this.props.approved}
                      />
                      {this.state.newType === "PA" && (
                        <TextField
                          fullWidth
                          margin="normal"
                          label="Quarter(s)"
                          variant="outlined"
                          type="text"
                          size="small"
                          name="newQuarter"
                          value={this.state.newQuarter}
                          onChange={this.handleInputChange}
                          disabled={this.props.approved}
                        />
                      )}
                      {this.state.newType === "Custom" && (
                        <TextField
                          fullWidth
                          margin="normal"
                          label="Custom Type"
                          variant="outlined"
                          type="text"
                          size="small"
                          name="newCustom"
                          value={this.state.newCustom}
                          onChange={this.handleInputChange}
                          disabled={this.props.approved}
                        />
                      )}
                      {this.props.side && (
                        <Autocomplete
                          autoHighlight
                          disableClearable
                          value={
                            (this.state.newDocType && {
                              value: this.state.newDocType,
                              label: this.state.newDocType,
                            }) ||
                            null
                          }
                          options={[
                            {
                              value: "Strategic Plan",
                              label: "Strategic Plan",
                            },
                            { value: "Order Form", label: "Order Form" },
                            {
                              value: "Research Report",
                              label: "Research Report",
                            },
                            // {
                            //   value: "Biologics Report Order Form",
                            //   label: "Biologics Report Order Form"
                            // },
                            // {
                            //   value: "Covid Report Order Form",
                            //   label: "Covid Report Order Form"
                            // },
                            {
                              value: "Exhibit/Event Proposal",
                              label: "Exhibit/Event Proposal",
                            },
                            { value: "Gift Estimate", label: "Gift Estimate" },
                            {
                              value: "Statement of Work",
                              label: "Statement of Work",
                            },
                            { value: "Proposal", label: "Proposal" },
                          ]}
                          getOptionLabel={(option) => option?.label || ""}
                          getOptionSelected={(option, value) =>
                            option.value === value.value
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="SOW Type"
                              variant="outlined"
                              size="small"
                              margin="normal"
                              required
                              InputLabelProps={{ required: false }}
                            />
                          )}
                          onChange={(e, value) =>
                            this.handleReactSelect("newDocType", value)
                          }
                          disabled={this.props.approved}
                        />
                      )}
                      <Autocomplete
                        autoHighlight
                        disableClearable
                        value={
                          (this.state.newYear && {
                            value: this.state.newYear,
                            label: this.state.newYear,
                          }) ||
                          null
                        }
                        options={[
                          { value: "2022", label: "2022" },
                          { value: "2023", label: "2023" },
                          { value: "2024", label: "2024" },
                          { value: "2025", label: "2025" },
                          { value: "2026", label: "2026" },
                          { value: "2027", label: "2027" },
                        ]}
                        getOptionLabel={(option) => option?.label || ""}
                        getOptionSelected={(option, value) =>
                          option.value === value.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Contract Year"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            required
                            InputLabelProps={{ required: false }}
                          />
                        )}
                        onChange={(e, value) =>
                          this.handleReactSelect("newYear", value)
                        }
                        disabled={this.props.approved}
                      />

                      {this.props.side ? (
                        <>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            value={
                              this.state.newCurrency && {
                                value: this.state.newCurrency,
                                label: this.state.newCurrency,
                              }
                            }
                            options={[
                              { value: "USD", label: "USD ($)" },
                              { value: "EUR", label: "EUR (€)" },
                              { value: "GBP", label: "GBP (£)" },
                            ]}
                            getOptionLabel={(option) => option?.label || ""}
                            getOptionSelected={(option, value) => {
                              // console.log(option);
                              // console.log(value);
                              return option.value === value.value
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Currency"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                required
                                InputLabelProps={{ required: false }}
                              />
                            )}
                            onChange={(e, value) =>
                              this.handleReactSelect("newCurrency", value)
                            }
                            disabled={this.props.approved}
                          />
                          <DatePicker
                            size="small"
                            label="SOW Date"
                            inputFormat="MM/DD/yyyy"
                            value={this.state.newCustomDate || this.state.date}
                            onChange={(value) =>
                              this.handleDateChange("newCustomDate", value)
                            }
                            renderInput={(params) => (
                              <Tooltip
                                disableInteractive
                                placement="left"
                                title="Date to display on the SOW"
                              >
                                <TextField {...params} size="small" />
                              </Tooltip>
                            )}
                            disabled={this.props.approved}
                          />
                          <DatePicker
                            size="small"
                            label="Signature Date"
                            inputFormat="MM/DD/yyyy"
                            value={this.state.newSigDate}
                            onChange={(value) =>
                              this.handleDateChange("newSigDate", value)
                            }
                            renderInput={(params) => (
                              <Tooltip
                                disableInteractive
                                placement="left"
                                title="Date to display under the signature"
                              >
                                <TextField {...params} size="small" />
                              </Tooltip>
                            )}
                            disabled={this.props.approved}
                          />
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            value={
                              this.state.newAddress && {
                                value: this.state.newAddress,
                                label: this.state.newAddress,
                              }
                            }
                            options={[
                              { value: "New York", label: "New York" },
                              { value: "Paris", label: "Paris" },
                            ]}
                            getOptionLabel={(option) => option?.label || ""}
                            getOptionSelected={(option, value) =>
                              option.value === value.value
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Address"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                required
                                InputLabelProps={{ required: false }}
                              />
                            )}
                            onChange={(e, value) =>
                              this.handleReactSelect("newAddress", value)
                            }
                            disabled={this.props.approved}
                          />

                          <Autocomplete
                            multiple
                            autoHighlight
                            className="public-btn"
                            value={this.state.newSalesPerson}
                            options={this.state.memberOptions}
                            getOptionLabel={(option) => option?.label || ""}
                            getOptionSelected={(option, value) =>
                              option.value === value.value
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sales Person"
                                variant="outlined"
                                size="small"
                                margin="normal"
                              />
                            )}
                            onChange={(e, value) =>
                              this.handleReactSelectMulti(
                                "newSalesPerson",
                                value
                              )
                            }
                            onOpen={this.createMemberOptions}
                          />
                          <Autocomplete
                            multiple
                            autoHighlight
                            className="public-btn"
                            value={this.state.newAccountManagement}
                            options={this.state.memberOptions}
                            getOptionLabel={(option) => option?.label || ""}
                            getOptionSelected={(option, value) =>
                              option.value === value.value
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Account Management"
                                variant="outlined"
                                size="small"
                                margin="normal"
                              />
                            )}
                            onChange={(e, value) =>
                              this.handleReactSelectMulti(
                                "newAccountManagement",
                                value
                              )
                            }
                            onOpen={this.createMemberOptions}
                          />
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            value={
                              this.state.newLogoInternal && {
                                value: this.state.newLogoInternal,
                                label: this.state.newLogoInternal,
                              }
                            }
                            options={[
                              { value: Logo, label: "That's Nice" },
                              { value: LogoPA, label: "Pharma's Almanac" },
                              { value: LogoDisAMR, label: "disAMR" },
                            ]}
                            getOptionLabel={(option) => option?.label || ""}
                            getOptionSelected={(option, value) =>
                              option.value === value.value
                            }
                            renderInput={(params) => { 
                              return (
                              <div class="internal-logo-wrapper">
                                <img src={params.inputProps.value} alt="internal-logo" />
                                <TextField
                                  {...params}
                                  label="Internal Logo"
                                  variant="outlined"
                                  size="small"
                                  margin="normal"
                                  required
                                  InputLabelProps={{ required: false }}
                                >
                                </TextField>
                              </div>
                            )}}
                            renderOption={(params,option) => {
                              return (
                                <MenuItem {...params} class="internal-logo-option">
                                  <img src={option.value} alt="internal-logo" />
                                </MenuItem>
                              );
                            }}
                            onChange={(e, value) => {
                              this.handleReactSelect("newLogoInternal", value)
                            }}
                            disabled={this.props.approved}
                          />
                        </>
                      ) : (
                        ""
                      )}
                      {!this.props.approved && (
                        <Grid mt={1}>
                          <LoadingButton
                            disableElevation
                            id="apply-btn"
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ width: "100%" }}
                            pending={this.props.adding}
                          >
                            {this.props.side ? "Apply" : "Create SOW"}
                          </LoadingButton>
                        </Grid>
                      )}
                    </form>
                  </TabPanel>
                  <TabPanel value={this.state.tab} index={1}>
                    <div id="revisions">
                      {this.props.revisions && this.props.revisions.length ? (
                        <List className={`revision-list small`}>
                          {this.props.revisions.map((revision, i) => {
                            return (
                              <ListItem
                                button
                                key={`revision-${i}`}
                                data-id={revision._id.toString()}
                                className={`revision editable ${
                                  this.props.revisionIndex === i
                                    ? "selected"
                                    : ""
                                }`}
                                onClick={() => {
                                  this.props.loadRevision(
                                    revision._id.toString(),
                                    i
                                  );
                                }}
                              >
                                <span>
                                  {moment(
                                    revision.saved.time ||
                                      ObjectID(revision._id).getTimestamp()
                                  ).format("lll")}
                                  &emsp;{" "}
                                  {revision.data.approved &&
                                    !revision.data.sentToClient &&
                                    !revision.data.rejected && (
                                      <Chip
                                        size="small"
                                        label="Approved"
                                        color="success"
                                      />
                                    )}
                                  {!revision.data.approved &&
                                    revision.data.sentToClient &&
                                    !revision.data.rejected && (
                                      <Chip
                                        size="small"
                                        label="Sent to Client"
                                        color="info"
                                      />
                                    )}
                                  {!revision.data.approved &&
                                    !revision.data.sentToClient &&
                                    revision.data.rejected && (
                                      <Chip
                                        size="small"
                                        label="Rejected"
                                        color="error"
                                      />
                                    )}
                                  {!revision.data.approved &&
                                    !revision.data.sentToClient &&
                                    revision.data.revised && (
                                      <Chip
                                        size="small"
                                        label="Revised"
                                        color="secondary"
                                      />
                                    )}
                                </span>
                                <span className="by-line">
                                  by{" "}
                                  {this.getUserInfo(revision.saved.id)?.name ||
                                    revision.saved.name}
                                </span>
                              </ListItem>
                            );
                          })}
                        </List>
                      ) : (
                        <Box
                          p={2}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="overline" color="textSecondary">
                            No recent revisions
                          </Typography>
                        </Box>
                      )}
                      {this.props.revisions &&
                        this.props.totalRevisions >
                          this.props.revisions.length && (
                          <Box mb={2}>
                            <LoadingButton
                              fullWidth
                              type="button"
                              variant="outlined"
                              onClick={this.props.loadMoreRevisions}
                              pending={this.props.loadingMoreRevisions}
                            >
                              Load More
                            </LoadingButton>
                            <br />
                          </Box>
                        )}
                      {typeof this.props.revisionIndex === "number" ? (
                        <Box
                          display="flex"
                          fullWidth
                          sx={{
                            "&": {
                              m: -0.5,
                            },
                            "& > :not(style)": {
                              flex: 1,
                              m: 0.5,
                            },
                          }}
                        >
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={this.props.applyRevision}
                          >
                            Revert
                          </Button>
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={this.props.cancelRevision}
                          >
                            Cancel
                          </Button>
                        </Box>
                      ) : (
                        ""
                      )}
                    </div>
                  </TabPanel>
                </div>
              </div>
              <Box id="additional-settings" pb={2}>
                {sessionStorage.getItem("sow-recent-history") &&
                  JSON.parse(sessionStorage.getItem("sow-recent-history"))
                    ?.docNum === this.props.docNum && (
                    <Box mb={2}>
                      <Button
                        fullWidth
                        size="small"
                        color="secondary"
                        variant="outlined"
                        onClick={this.props.restore}
                      >
                        Restore Unsaved Changes
                      </Button>
                    </Box>
                  )}
                <Box
                  display="flex"
                  sx={{
                    "&": {
                      m: -0.5,
                    },
                    "& > :not(style)": {
                      flex: 1,
                      m: 0.5,
                    },
                  }}
                >
                  <Tooltip
                    disableInteractive
                    placement="top"
                    title="Clone"
                    enterDelay={250}
                    enterNextDelay={250}
                  >
                    <LoadingButton
                      size="small"
                      variant="outlined"
                      color="secondary"
                      id="clone-doc"
                      className="public-btn"
                      onClick={this.props.clone}
                      pending={this.props.cloning}
                    >
                      <FileCopyIcon fontSize="small" />
                    </LoadingButton>
                  </Tooltip>
                  {this.props.docNum !== "MAST" && !this.props.approved && (
                    <Tooltip
                      disableInteractive
                      placement="top"
                      title="New Version"
                      enterDelay={250}
                      enterNextDelay={250}
                    >
                      <LoadingButton
                        size="small"
                        variant="outlined"
                        color="secondary"
                        id="new-version"
                        onClick={this.props.newVersion}
                        pending={this.props.cloning}
                      >
                        <AddBoxIcon fontSize="small" />
                      </LoadingButton>
                    </Tooltip>
                  )}

                  {(this.props.approved || this.props.docNum === "MAST") && (
                    <Tooltip
                      disableInteractive
                      placement="top"
                      title="Briefs"
                      enterDelay={250}
                      enterNextDelay={250}
                    >
                      <Button
                        component={Link}
                        size="small"
                        variant="outlined"
                        className="public-btn"
                        to={`/${this.props.match.params.id}/brief`}
                      >
                        <AssignmentIcon fontSize="small" />
                      </Button>
                    </Tooltip>
                  )}
                  {/* {this.props.importingTeamwork ? (
              <Button variant="link" disabled className="public-btn">
                <Spinner animation="border" role="status" size="small">
                  <span className="sr-only">Loading...</span>
                </Spinner>
                &nbsp;Importing into Teamwork...
              </Button>
            ) : this.props.teamworkID ? (
              <Button
                variant="link"
                href={`https://thatsnice.teamwork.com/#/projects/${this.props.teamworkID}/tasks`}
                target="_blank"
                className="public-btn"
              >
                View Teamwork Project
              </Button>
            ) : (
              <Button
                variant="link"
                id="import-teamwork"
                className="text-primary public-btn"
                onClick={this.props.importTeamwork}
              >
                Import into Teamwork
              </Button>
            )} */}

                  {/* <br />
            <Button
              variant="link"
              id="delete-doc"
              className="text-danger"
              onClick={this.props.delete}
            >
              Delete Document
            </Button> */}
                  {!this.props.approved && (
                    <>
                      {this.props.docNum !== "MAST" && this.props.rejected ? (
                        <Tooltip
                          disableInteractive
                          placement="top"
                          title="Unreject"
                          enterDelay={250}
                          enterNextDelay={250}
                        >
                          <Button
                            disableElevation
                            size="small"
                            variant="contained"
                            color="error"
                            id="unreject-doc"
                            onClick={this.props.unrejectSOW}
                          >
                            <ThumbDownIcon fontSize="small" />
                          </Button>
                        </Tooltip>
                      ) : (
                        <Tooltip
                          disableInteractive
                          placement="top"
                          title="Reject"
                          enterDelay={250}
                          enterNextDelay={250}
                        >
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            id="reject-doc"
                            onClick={this.props.rejectSOW}
                          >
                            <ThumbDownIcon fontSize="small" />
                          </Button>
                        </Tooltip>
                      )}
                    </>
                  )}

                  {/* <hr />
            <div className="small text-secondary">
              {this.props.lastModified ? (
                <>
                  <span>
                    Last modified by: <br />
                    {this.props.lastModified.name}{" "}
                    <span
                      title={moment(this.props.lastModified.time).format(
                        "LLLL"
                      )}
                    >
                      ({moment(this.props.lastModified.time).fromNow()})
                    </span>
                  </span>
                  <br />
                  <br />
                </React.Fragment>
              ) : null}
              <span>
                Created by: <br />
                {this.props.createdBy}
              </span>
            </div> */}
                </Box>
                <hr />
                <Box className="small">
                  <Box>
                    Created by:
                    <Grid display="flex">
                      <Grid
                        item
                        mr={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="content"
                      >
                        <Avatar
                          alt={this.getUserInfo(this.props.createdBy)?.name}
                          src={this.getUserInfo(this.props.createdBy)?.picture}
                          sx={{
                            "&": {
                              width: 30,
                              height: 30,
                            },
                          }}
                        />
                      </Grid>
                      <Grid item>
                        {this.getUserInfo(this.props.createdBy)?.name ||
                          "User not found"}
                        <br />
                        <em>{moment(this.props.createdAt).format("llll")}</em>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </div>
        </Container>
      </Drawer>
    );
  }
}

Settings.propTypes = {
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  company: PropTypes.string,
  type: PropTypes.string,
  quarter: PropTypes.string,
  custom: PropTypes.string,
  year: PropTypes.string,
  adding: PropTypes.bool,
  show: PropTypes.bool,
  docNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  docType: PropTypes.string,
  // date: PropTypes.number
  currency: PropTypes.string,
  delete: PropTypes.func,
  clone: PropTypes.func,
  newVersion: PropTypes.func,
  createdBy: PropTypes.string,
  lastModified: PropTypes.object,
  fromMember: PropTypes.array,
  revisions: PropTypes.array,
  loadRevision: PropTypes.func,
  cancelRevision: PropTypes.func,
  applyRevision: PropTypes.func,
  revisionIndex: PropTypes.number,
  totalRevisions: PropTypes.number,
  loadMoreRevisions: PropTypes.func,
  restore: PropTypes.func,
  // createdAt: PropTypes.string,
  normalAdmin: PropTypes.bool,
};

export default withRouter(Settings);
